import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../components/site/Seo";
import { HomeHero } from "../components/home/HomeHero";
import { Marquee } from "../components/site/Marquee";
import { Benefits } from "../components/home/Benefits";
import { Segment } from "../components/home/Segment";
import { ServicesGrid } from "../components/site/ServicesGrid";
import { Steps } from "../components/site/Steps";
import { TrustSection } from "../components/home/TrustSection";
import { FaqSection } from "../components/site/FaqSection";
import { CtaFinal } from "../components/site/CtaFinal";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { QUOTE_PATH } from "../lib/site";

export default function HomePage() {
  return (
    <>
      <Seo title="Mega Solar | Instalação de Painéis Solares em Portugal" path="/"
        description="Instalação de painéis solares fotovoltaicos para habitações e empresas em Portugal. Soluções de energia solar dimensionadas ao seu consumo. Peça um orçamento gratuito." />
      <HomeHero />
      <Marquee />
      <Benefits />
      <div id="solucoes">
        <Segment testId="residential-section" eyebrow="Soluções residenciais" title="Energia solar para a sua casa."
          text="Uma solução fotovoltaica para a sua habitação deve ser dimensionada de acordo com o consumo, o perfil de utilização e as características da casa — orientação, inclinação e tipo de telhado."
          points={["Análise das faturas e dos hábitos de consumo", "Avaliação do telhado, da orientação e de sombras", "Possibilidade de analisar armazenamento, sob consulta"]}
          image="/images/moradia.jpg" alt="Moradia com painéis solares fotovoltaicos no telhado e jardim em dia de sol"
          cta="Pedir Orçamento Residencial" to="/solucoes-residenciais" />
        <Segment testId="business-section" dark reverse eyebrow="Soluções empresariais" title="Soluções solares para empresas."
          text="Para empresas que pretendem avaliar o potencial de produção solar, melhorar a eficiência energética e gerir os seus custos operacionais, começamos por perceber quando e quanto a sua atividade consome."
          points={["Avaliação do perfil de consumo durante o dia", "Análise da área disponível em cobertura ou no solo", "Proposta comercial clara, com pressupostos transparentes"]}
          image="/images/empresa.jpg" alt="Vista aérea de edifícios industriais com painéis solares fotovoltaicos na cobertura"
          cta="Solicitar Proposta Empresarial" to="/solucoes-empresariais" />
      </div>
      <section data-testid="services-section" className="bg-paper py-24 sm:py-32">
        <div className="container-x">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <Eyebrow>Serviços</Eyebrow>
              <Reveal><h2 className="mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-tight text-forest sm:text-5xl lg:text-6xl">Do primeiro contacto à instalação.</h2></Reveal>
            </div>
            <Link to="/servicos" className="btn-outline group w-fit" data-testid="services-all-link">Ver todos os serviços <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" /></Link>
          </div>
          <div className="mt-14"><ServicesGrid /></div>
          <Reveal className="mt-12 flex flex-col items-start gap-5 rounded-[1.75rem] bg-forest p-8 text-white sm:flex-row sm:items-center sm:justify-between sm:p-10">
            <p className="font-display text-2xl font-medium tracking-tight sm:text-3xl">Não sabe qual a solução indicada?</p>
            <Link to={QUOTE_PATH} className="btn-gold" data-testid="services-quote-button">Pedir Orçamento Gratuito</Link>
          </Reveal>
        </div>
      </section>
      <section data-testid="how-it-works-section" className="bg-forest-deep py-24 text-white sm:py-32">
        <div className="container-x">
          <Eyebrow light>Como funciona</Eyebrow>
          <Reveal><h2 className="mt-5 max-w-3xl font-display text-4xl font-semibold leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">Quatro etapas, um processo transparente.</h2></Reveal>
          <div className="mt-16"><Steps light /></div>
        </div>
      </section>
      <TrustSection />
      <FaqSection />
      <CtaFinal />
    </>
  );
}
